var map = {
	"./cm.svg": "5d6d",
	"./coin-keeper.svg": "f23f",
	"./crocus.svg": "9dfe",
	"./data-solution.svg": "6aa0",
	"./embria.svg": "fa37",
	"./first-tv.svg": "ceed",
	"./glispa.svg": "d785",
	"./herocraft.svg": "cea0",
	"./i-digital.svg": "37e7",
	"./i-free.svg": "3327",
	"./ifree.svg": "afe3",
	"./just-ai.svg": "a241",
	"./last-backend.svg": "cf0d",
	"./my-games.svg": "6a89",
	"./nalunch.svg": "30b6",
	"./ottmedia.png": "98e5",
	"./sber-chorus.svg": "81ab",
	"./space307.svg": "46d4",
	"./sum-and-substance.svg": "0554",
	"./trading-view.svg": "2a31",
	"./wallet.svg": "96f3",
	"./ya.svg": "e197",
	"./zillion-whales.svg": "ca8b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc7b";